var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91667 17.4133C2.30584 17.4133 1 16.1074 1 14.4966C1 13.1003 1.98117 11.9332 3.29167 11.647V9.07988C3.29167 8.73468 3.57149 8.45488 3.91667 8.45488H7.875V6.51278C6.56451 6.22668 5.58333 5.05958 5.58333 3.66328C5.58333 2.05238 6.88917 0.746582 8.5 0.746582C10.1108 0.746582 11.4167 2.05238 11.4167 3.66328C11.4167 5.05958 10.4355 6.22668 9.125 6.51278V8.45488H13.0833C13.4285 8.45488 13.7083 8.73468 13.7083 9.07988V11.647C15.0188 11.9332 16 13.1003 16 14.4966C16 16.1074 14.6942 17.4133 13.0833 17.4133C11.4725 17.4133 10.1667 16.1074 10.1667 14.4966C10.1667 13.1003 11.1478 11.9332 12.4583 11.647V9.7049H4.54167V11.647C5.85216 11.9332 6.83333 13.1003 6.83333 14.4966C6.83333 16.1074 5.5275 17.4133 3.91667 17.4133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.0800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIcon);
export default __webpack_public_path__ + "static/media/process-icon.3abef08967719a8d8afd6babe6186144.svg";
export { ForwardRef as ReactComponent };